import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ApiRedirectGuard } from './routes/guards/api-redirect.guard';
import { AuthGuard } from './routes/guards/auth.guard';
import { LoginGuard } from './routes/guards/login.guard';

const routes: Routes = [
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin-routing.module').then(m => m.AdminRoutingModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'admin',
    loadChildren: () => import('./admin/workflows/workflow-dashboard-routing.module')
      .then(m => m.WorkflowsRoutingModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'borrower',
    loadChildren: () => import('./borrower/borrower-page-routing.module').then(m => m.BorrowerPageRoutingModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'today',
    loadChildren: () => import('./modules/today/today-routing.module').then(m => m.TodayRoutingModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'funnel',
    loadChildren: () => import('./modules/funnel/funnel-routing.module').then(m => m.FunnelRoutingModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'deals',
    loadChildren: () => import('./modules/team-deals/team-deals-routing.module').then(m => m.TeamDealsRoutingModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'list',
    loadChildren: () => import('./borrower-index/borrower-index-routing.module').then(m => m.BorrowerIndexRoutingModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'login',
    loadChildren: () => import('./routes/login/login-routing.module').then(m => m.LoginRoutingModule),
    canActivate: [LoginGuard]
  },
  {
    path: 'nova',
    loadChildren: () => import('./page-not-found/page-not-found-routing.module').then(m => m.PageNotFoundRoutingModule),
    canActivate: [ApiRedirectGuard]
  },
  {
    path: 'performance',
    loadChildren: () => import('./performance/performance-routing.module').then(m => m.PerformanceRoutingModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'cx-performance',
    loadChildren: () => import('./performance-cx/cx-performance-routing.module').then(m => m.CXPerformanceRoutingModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'ring-draw-deals',
    loadChildren: () => import('./admin/ring-draw-deals/ring-draw-deals-routing.module').then(m => m.RingDrawDealsRoutingModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'rollbar',
    loadChildren: () => import('./rollbar-test/rollbar-test-routing.module').then(m => m.RollbarTestRoutingModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'schedule',
    loadChildren: () => import('./schedule-reminder/schedule-reminder-routing.module').then(m => m.ScheduleReminderRoutingModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'settings',
    loadChildren: () => import('./user-settings/user-settings-routing.module').then(m => m.UserSettingsRoutingModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'token',
    loadChildren: () => import('./routes/token/token-routing.module').then(m => m.TokenRoutingModule)
  },
  {
    path: 'auth-error',
    loadChildren: () => import('./auth-error/auth-error-routing.module').then(m => m.AuthErrorRoutingModule)
  },
  {
    path: '',
    loadChildren: () => import('./modules/task-management/task-management-routing.module').then(m => m.TaskManagementRoutingModule),
    canActivate: [AuthGuard]
  },
  {
    path: '**',
    loadChildren: () => import('./page-not-found/page-not-found-routing.module').then(m => m.PageNotFoundRoutingModule),
    canActivate: [AuthGuard]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
